import VerifyPhoneCode from './VerifyPhoneCode'

export default VerifyPhoneCode
